export const generateFavouriteId = (storedFavourites) => {
  // If there are no stored favourites, start with ID 1
  if (!storedFavourites || storedFavourites.length === 0) {
    return 1;
  }

  // Find the highest existing ID and increment by 1
  const maxId = Math.max(
    ...storedFavourites.map(
      (favourite) =>
        // Handle both numeric and string IDs, defaulting to 0 if invalid
        parseInt(favourite.id) || 0
    )
  );

  return maxId + 1;
};
